import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51608cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "group-title" }
const _hoisted_4 = { style: {"float":"left"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "报销事由")
], -1))
const _hoisted_7 = { class: "total" }
const _hoisted_8 = { style: {"float":"right"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_12 = { class: "submit-btn" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onActivated, onMounted, reactive, ref, watch } from 'vue'
import SimpImageUpload from '@/components/SimpImageUpload.vue'
import ReviewPeople from '@/components/review-people/ReviewPeople.vue'
import { uploadFileItem } from '@/apis/base'
import { getPubFeeType } from '@/apis/expenseDeclaration'
import { FeeSave } from '@/apis/expenseDeclaration'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'
import { Toast } from 'vant'
import { ApproveConfig, CarboncopyConfig } from '@/apis/public/oauth'
interface costList {
  id?: number
  typeName?: string
  type_id?: string // 报销类型
  money?: number // 金额（元）
  date?: string // 时间
  explain?: string // 说明
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentDate = ref(new Date(dayjs().format('YYYY-MM-DD HH:mm')))

const router = useRouter()
const route = useRoute()

const TypeName = {
  //  自定义 columns 结构中的字段
  text: 'name',
  children: 'cities'
}
const state = reactive({
  formData: {
    pics: null,
    money: 0,
    name: '',
    project_id: '',
    list: [{ id: 1 } as costList]
  },

  showTypePicker: false,
  showTimePicker: false,
  money: null,
  curIndex: null
})

const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

const allMoney = ref(0)

watch(state.formData.list, (newVal, oldVal) => {
  // console.log('ticket add fileList ===>', newVal)
  allMoney.value = newVal.reduce((pre, cur, index, arr) => {
    return pre + Number(cur.money)
  }, 0)
})

const fileList = ref<Array<uploadFileItem>>([])
watch(fileList, (newVal, oldVal) => {
  console.log('ticket add fileList ===>', newVal)
  // data.saveData.upload_file_list = newVal
  state.formData.pics = newVal
})

const review_carbon = ref({
  review: [],
  carbon: []
})

const get_approve_config = async () => {
  let typeId = {
    type: 1
  }
  const res = await ApproveConfig(typeId)
  const res1 = await CarboncopyConfig(typeId)
  if (res.code === 200) {
    if (res.data) {
      res.data.forEach(e => {
        review_carbon.value.review.push(e.staff)
      })
    }
  }
  if (res1.code === 200) {
    if (res1.data) {
      res1.data.forEach(e => {
        review_carbon.value.carbon.push(e.staff)
      })
    }
  }
}

const overallId = ref(0)

const reimburseColumns = ref([])

const get_pubType = async () => {
  const res = await getPubFeeType()
  if (res.code == 200) {
    res.data.forEach(e => {
      reimburseColumns.value.push({ id: e.id, name: e.name, cities: e.children })
    })
  }
}

const formatDate = date => {
  return `${dayjs(date).format('YYYY-MM-DD')}`
}

const onClickItem = val => {
  state.curIndex = val
}

const onClickTime = (id: number) => {
  overallId.value = id
  state.showTimePicker = true
}

const onClickType = (id: number) => {
  console.log('ontype', id)
  overallId.value = id
  state.showTypePicker = true
}

const onReimburseConfirm = (val: object) => {
  state.formData.list.forEach(l => {
    if (l.id == overallId.value) {
      l.type_id = val[1].id
      l.typeName = `${val[0].name}-${val[1].name}`
    }
  })

  state.showTypePicker = false
}

const onTimeConfirm = (val: object) => {
  state.formData.list.forEach(l => {
    if (l.id == overallId.value) {
      l.date = formatDate(val)
    }
  })
  state.showTimePicker = false
}

const addList = () => {
  state.formData.list.push({ id: state.formData.list.length + 1 } as costList)
}
const delList = val => {
  state.formData.list.splice(val, 1)
}

const onSubmit = async () => {
  let data = {
    total_money: allMoney.value, // 全部金额
    pics: state.formData.pics, // 报销图片
    project_id: state.formData.project_id, // 项目id
    details: [] //
  }
  state.formData.list.forEach(l => {
    data.details.push({ type_id: l.type_id, money: l.money, explain: l.explain, date: l.date })
  })
  const res = await FeeSave(data)
  if (res.code == 200) {
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  state.formData.project_id = router.currentRoute.value.query.project_id.toString()
  state.formData.name = router.currentRoute.value.query.project_name.toString()
  get_pubType()
  get_approve_config() // 获取审批人流程数据
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, {
      class: "form",
      onSubmit: onSubmit,
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              required: "",
              modelValue: _unref(state).formData.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).formData.name) = $event)),
              name: "name",
              label: "项目名称",
              placeholder: "项目名称",
              rules: [{ required: true, message: '请填写项目名称' }]
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).formData.list, (v, k) => {
          return (_openBlock(), _createElementBlock("div", {
            key: k,
            onClick: ($event: any) => (onClickItem(k))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString('费用明细(' + (k + 1) + ')'), 1),
              (k > 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    style: {"float":"right","color":"#2a82e4"},
                    onClick: ($event: any) => (delList(k))
                  }, "删除", 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: v.typeName,
                  "onUpdate:modelValue": ($event: any) => ((v.typeName) = $event),
                  required: "",
                  "is-link": "",
                  name: "type",
                  label: "报销类型",
                  readonly: "",
                  placeholder: "请选择",
                  onClick: ($event: any) => (onClickType(v.id))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
                _createVNode(_component_van_popup, {
                  show: _unref(state).showTypePicker,
                  "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).showTypePicker) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_picker, {
                      "columns-field-names": TypeName,
                      columns: reimburseColumns.value,
                      onConfirm: onReimburseConfirm,
                      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).showTypePicker = false))
                    }, null, 8, ["columns"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_cell, { title: "报销事由" }, {
                  title: _withCtx(() => [
                    _hoisted_6
                  ]),
                  label: _withCtx(() => [
                    _createVNode(_component_van_field, {
                      modelValue: v.explain,
                      "onUpdate:modelValue": ($event: any) => ((v.explain) = $event),
                      "input-align": "left",
                      rows: "2",
                      autosize: "",
                      type: "textarea",
                      placeholder: "请输入报销事由",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_field, {
                  modelValue: v.date,
                  "onUpdate:modelValue": ($event: any) => ((v.date) = $event),
                  required: "",
                  "is-link": "",
                  name: "time",
                  readonly: "",
                  label: "选择日期",
                  placeholder: "请选择",
                  onClick: ($event: any) => (onClickTime(v.id))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
                _createVNode(_component_van_popup, {
                  show: _unref(state).showTimePicker,
                  "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).showTimePicker) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      modelValue: currentDate.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentDate).value = $event)),
                      type: "date",
                      title: "选择日期",
                      onConfirm: onTimeConfirm,
                      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).showTimePicker = false))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  modelValue: v.money,
                  "onUpdate:modelValue": ($event: any) => ((v.money) = $event),
                  required: "",
                  name: "reason",
                  label: "金额（元）",
                  type: "number",
                  placeholder: "请输入"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_2))
        }), 128)),
        _createElementVNode("div", {
          class: "addItem",
          onClick: addList
        }, "+ 添加明细"),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, "金额（元）汇总：" + _toDisplayString(allMoney.value ? allMoney.value.toFixed(2) : 0), 1)
        ]),
        _createVNode(_component_van_cell, null, {
          title: _withCtx(() => [
            _hoisted_9
          ]),
          label: _withCtx(() => [
            _createVNode(SimpImageUpload, {
              isShowTitle: false,
              modelValue: fileList.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((fileList).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _hoisted_10,
        _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
        _hoisted_11,
        _createVNode(ReviewPeople, { review_carbon: review_carbon.value }, null, 8, ["review_carbon"]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_bottom_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})